export default __webpack_public_path__ + "static/media/fondo.b83c9cb0.png";